import { render, staticRenderFns } from "./ProductModal.vue?vue&type=template&id=569d0346&scoped=true"
import script from "./ProductModal.vue?vue&type=script&lang=js"
export * from "./ProductModal.vue?vue&type=script&lang=js"
import style0 from "./ProductModal.vue?vue&type=style&index=0&id=569d0346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569d0346",
  null
  
)

export default component.exports